module.exports = __webpack_public_path__ + "img/AT0000002599775.56fd820e.png";